import { memo, useCallback, useMemo, useRef } from "react";
import { Layouts } from "react-grid-layout";
import { Grid } from "ui/components/Grid";
import { GridRef } from "ui/components/Grid/types";
import { generateGridFromTemplate } from "ui/components/Grid/helper";
import { GRID_TEMPLATES } from "ui/components/Grid/templates";
import { CALCULATION_DETAIL_WIDGETS } from "./consts";
import { CalculationDetailCardProps } from "./types";

const STORAGE_KEY = "calculation-detail-state";
// Lijevi (vozilo) širi, desni (razrada) uži — kao na detaljima vozila.
const TEMPLATE = "two-columns-left";
const DEFAULT_HEIGHT = 14;

const CalculationDetailCard: React.FC<CalculationDetailCardProps> = (props) => {
  const { calculation } = props;

  const gridRef = useRef<GridRef>(null);

  const savedState = useMemo(
    () => JSON.parse(localStorage.getItem(STORAGE_KEY) || "null"),
    []
  );

  const { widgets, layouts } = useMemo(() => {
    const templateConfig =
      GRID_TEMPLATES.find((tpl) => tpl.id === TEMPLATE) || GRID_TEMPLATES[0];
    const base = generateGridFromTemplate(
      templateConfig,
      CALCULATION_DETAIL_WIDGETS(calculation)
    );

    // Veća zadana visina kartica (korisnik ih svejedno može promijeniti/povući).
    return {
      widgets: base.widgets.map((w) => ({ ...w, h: DEFAULT_HEIGHT })),
      layouts: {
        lg: base.layouts.lg.map((l) => ({ ...l, h: DEFAULT_HEIGHT })),
      } as Layouts,
    };
  }, [calculation]);

  const saveLayout = useCallback((newLayouts: Layouts) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ layouts: newLayouts }));
  }, []);

  return (
    <div className="min-h-screen">
      <Grid
        key={calculation.id}
        ref={gridRef}
        rowHeight={50}
        initialWidgets={widgets}
        initialLayouts={savedState?.layouts ?? layouts}
        onLayoutChange={saveLayout}
      />
    </div>
  );
};

export default memo(CalculationDetailCard);
